// extracted by mini-css-extract-plugin
export default {"text":"OutlineText_text__VzuPr","face":"OutlineText_face__xgjaJ"};